<template>
  <header class="header non-printable header-white">
    <div class="header-wrapper">
      <div class="container">
        <div class="col-lg-2 col-xs-12 navigation-header">
          <a href="/" class="logo">
            <img
              class="non-printable"
              src="@/assets/img/logo.svg"
              alt="EFG HERMES"
              width="200"
              height="60"
            />
          </a>

          <button
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#navigation"
            aria-expanded="false"
            aria-controls="navigation"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>

        <div
          class="col-lg-8 col-xs-12 navigation-container"
          style="display: flex; justify-content: center"
        >
          <div id="navigation" class="navbar-collapse collapse">
            <ul class="navigation-list pull-right light-text">
              <li
                class="navigation-item"
                :class="{ current: activeLink == 'home' }"
              >
                <a class="navigation-link" href="/">Home</a>
              </li>
              <!-- <li class="navigation-item" :class="{current: activeLink == ''}">
                <a class="navigation-link" href="/markets">Markets</a>
              </li> -->
              <li
                class="navigation-item"
                :class="{ current: activeLink == 'Companies' }"
              >
                <a class="navigation-link" href="/auth/companies">Companies</a>
              </li>
              <!-- <li class="navigation-item" :class="{current: activeLink == ''}">
                <a class="navigation-link" href="/venue">Venue</a>
              </li> -->

              <!-- <li class="navigation-item" :class="{current: activeLink == ''}">
                <a class="navigation-link" href="/gallery">Gallery</a>
              </li> -->
              <li class="navigation-item">
                <a class="navigation-link" href="/#agenda">Agenda</a>
              </li>
              <li
                class="navigation-item"
                :class="{ current: activeLink == 'WebexGuide' }"
              >
                <a class="navigation-link" href="/webex-guide">WebEx Guide</a>
              </li>
              <li
                class="navigation-item"
                :class="{ current: activeLink == 'ImportantDeadlines' }"
              >
                <a class="navigation-link" href="/important-deadlines"
                  >Important Deadlines</a
                >
              </li>
              <!-- <li class="navigation-item" :class="{current: activeLink == ''}">
                <a class="navigation-link" href="/useful-information">Useful Information</a>
              </li>
              <li class="navigation-item" :class="{current: activeLink == ''}">
                <a class="navigation-link" href="/additional-services">Additional Services</a>
              </li>
              <li class="navigation-item" :class="{current: activeLink == ''}">
                <a class="navigation-link" href="/accommodation">Accommodation</a>
              </li> -->
              <li class="navigation-item">
                <a
                  href="mailto:VirtualConference@EFGHERMES.com"
                  class="navigation-link"
                  >Contact us</a
                >
              </li>
              <li class="navigation-item" v-if="isLoggedIn">
                <a
                  href="#"
                  class="navigation-link"
                  style="color: #ff1212"
                  @click.prevent="logout"
                  >Logout</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div
          class="col-lg-2 col-xs-12 navigation-header"
          style="margin-top: 8px"
        >
          <img
            src="/assets/img/nav-image.jpg"
            alt="EFG HEREMES"
            width="200"
            height="60"
          />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Navbar",
  props: ["activeLink"],
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$store.dispatch("endRegisrationProccess");
      this.$router.push("/");
    },
  },
};
</script>


<style scoped>
.logout-link {
  float: right;
  line-height: 100px;
  margin-right: 25px;
}
.navigation-link {
  text-transform: uppercase;
  font-size: 15px;
}
@media screen and (max-width: 74.9375em) {
  .navigation-link {
    padding: 14px 0;
  }
}

@media print {
  .non-printable {
    display: none;
  }
}
</style>
